interface BoxTruckBrowserTabGateProps {
    error: string | null
    switching: boolean
    onRetry: () => void
    onOpenFresh: () => void
}

/** Full-page target-tab gate shown while auth/company identity is unresolved or recoverable. */
export const BoxTruckBrowserTabGate = ({ error, switching, onRetry, onOpenFresh }: BoxTruckBrowserTabGateProps) => (
    <div className="flex min-h-full items-center justify-center bg-background px-6 text-foreground">
        <div className="flex max-w-sm flex-col items-center text-center">
            {error ? (
                <>
                    <div className="mb-3 flex size-10 items-center justify-center rounded-full bg-danger-soft text-danger">!</div>
                    <h1 className="text-base font-semibold">Couldn’t open this search</h1>
                    <p className="mt-1 text-sm text-foreground-muted">{error}</p>
                    <div className="mt-4 flex flex-wrap justify-center gap-2">
                        <button
                            type="button"
                            onClick={onRetry}
                            className="rounded-xl border-none bg-accent px-4 py-2 text-sm font-semibold text-accent-foreground hover:opacity-90"
                        >
                            Try again
                        </button>
                        <button
                            type="button"
                            onClick={onOpenFresh}
                            className="rounded-xl border border-border bg-surface px-4 py-2 text-sm font-semibold text-foreground hover:bg-default"
                        >
                            Open a new search
                        </button>
                    </div>
                </>
            ) : (
                <>
                    <span className="mb-3 size-8 animate-spin rounded-full border-2 border-border border-t-accent" aria-hidden="true" />
                    <h1 className="text-base font-semibold">Opening your search…</h1>
                    <p className="mt-1 text-sm text-foreground-muted">
                        {switching ? 'Switching this browser tab to the correct company.' : 'Restoring the search workspace.'}
                    </p>
                </>
            )}
        </div>
    </div>
)
